(() => {
  const indicators = Array.from(
    document.querySelectorAll("stock-level-indicator")
  );
  if (!indicators.length) return;

  const updateIndicator = (indicator, variantId) => {
    const wrappers = indicator.querySelectorAll(
      "[data-flow-selector='stock-level-indicator']"
    );
    if (!wrappers.length) return;
    wrappers.forEach((el) => {
      if (String(el.dataset.variantId) === String(variantId)) {
        el.classList.remove("hidden");
      } else {
        el.classList.add("hidden");
      }
    });
  };

  const getCurrentVariantId = (indicator) => {
    const productInfo = indicator.closest("product-info");
    const input =
      productInfo && productInfo.querySelector('input[name="id"]');
    if (input && input.value) return input.value;
    return indicator.dataset.flowVariantId;
  };

  indicators.forEach((indicator) => {
    const initial = getCurrentVariantId(indicator);
    if (initial) updateIndicator(indicator, initial);
  });

  document.addEventListener("variant:changed", (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) return;
    indicators.forEach((indicator) => {
      updateIndicator(indicator, variant.id);
    });
  });
})();
